import { defineStore } from 'pinia';
import {
  getCompanyList,
  getWasteCompaniesWhoseProjectsAreManagedByTransportCompany
} from '@/services/modules/company';

export const useCommonStore = defineStore('common', {
  state: () => ({
    userId: '',
    companyId: -1,
    companyList: [] as any[],
    selectedCompanyId: 'ALL',
    didInitRouter: false
  }),
  persist: true,
  actions: {
    changeUserId(id: string) {
      this.userId = id;
    },
    setCompanyId(id: number) {
      this.companyId = id;
    },
    async getCompanyList() {
      let res: any = await getCompanyList();
      this.companyList = res.map((item: any) => {
        return {
          value: item.id,
          label: item.name,
          type: item.type
        };
      });
    },
    async getWasteCompaniesWhoseProjectsAreManagedByTransportCompany() {
      let res: any = await getWasteCompaniesWhoseProjectsAreManagedByTransportCompany();
      this.companyList = res.map((item: any) => {
        return {
          value: item.id,
          label: item.name
        };
      });
    }
  }
});
